module.exports = __webpack_public_path__ + "static/media/pa.d807798e.svg";